var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillsByTextEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 87,
    viewBox: "0 0 194 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.392 35.0381H169.529V55.1855H175.392V35.0381Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.265 51.3957L165.004 34.5547L136.378 34.8144L119.013 51.6039L119.364 51.8278H119.238V86.7501H179.226V51.8278L179.265 51.3957Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.019 34.5908L147.203 55.3245V86.7503H179.226V51.3803L165.019 34.5908Z",
    fill: "#E6E6E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166.597 69.3711H160.057V75.1092H166.597V69.3711Z",
    fill: "#3F3D56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M166.597 59.4395H160.057V65.0866H166.597V59.4395Z",
    fill: "#3F3D56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M166.597 69.3711H160.057V75.1092H166.597V69.3711Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M166.597 59.4395H160.057V65.0866H166.597V59.4395Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.533 67.8486H130.993V73.5868H137.533V67.8486Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.533 57.917H130.993V63.5641H137.533V57.917Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M129.122 35.0381H123.258V55.1855H129.122V35.0381Z",
    fill: "#F2F2F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M132.993 51.3957L118.732 34.5547L90.1065 34.8144L72.7415 51.6039L73.0924 51.8278H72.967V86.7501H132.955V51.8278L132.993 51.3957Z",
    fill: "#F2F2F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M118.748 34.5908L100.932 55.3245V86.7503H132.955V51.3803L118.748 34.5908Z",
    fill: "#E6E6E6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M120.326 69.3711H113.786V75.1092H120.326V69.3711Z",
    fill: "#3F3D56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M120.326 59.4395H113.786V65.0866H120.326V59.4395Z",
    fill: "#3F3D56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M120.326 69.3711H113.786V75.1092H120.326V69.3711Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M120.326 59.4395H113.786V65.0866H120.326V59.4395Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2622 67.8486H84.7222V73.5868H91.2622V67.8486Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2622 57.917H84.7222V63.5641H91.2622V57.917Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M81.743 17.6504H73.908V44.5723H81.743V17.6504Z",
    fill: "#F2F2F2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9169 39.5083L67.8608 17.0049L29.6097 17.3519L6.40601 39.7868L6.87474 40.0859H6.70735V86.7505H86.8656V40.0859L86.9169 39.5083Z",
    fill: "#F2F2F2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8806 17.0527L44.0742 44.7581V86.7505H86.8655V39.4876L67.8806 17.0527Z",
    fill: "#E6E6E6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9902 63.5273H61.2511V71.1949H69.9902V63.5273Z",
    fill: "#3F3D56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9902 50.2559H61.2511V57.8018H69.9902V50.2559Z",
    fill: "#3F3D56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9902 63.5273H61.2511V71.1949H69.9902V63.5273Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9902 50.2559H61.2511V57.8018H69.9902V50.2559Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1534 61.4932H22.4143V69.1607H31.1534V61.4932Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1534 48.2217H22.4143V55.7676H31.1534V48.2217Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M187.407 86.5781H0V86.9641H187.407V86.5781Z",
    fill: "#3F3D56"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5267 79.4814C32.6512 79.4814 35.1841 74.3513 35.1841 68.0229C35.1841 61.6946 32.6512 56.5645 29.5267 56.5645C26.4023 56.5645 23.8694 61.6946 23.8694 68.0229C23.8694 74.3513 26.4023 79.4814 29.5267 79.4814Z",
    fill: "#3F3D56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0485 86.7778C27.7827 73.2832 30.0257 59.8373 30.0486 59.7031L30.4894 59.7772C30.4665 59.9107 28.2364 73.286 30.4895 86.705L30.0485 86.7778Z",
    fill: "#647893"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5075 65.5582L29.3917 68.2744L29.6026 68.6658L34.7184 65.9495L34.5075 65.5582Z",
    fill: "#647893"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2033 66.9193L23.9923 67.3105L29.1075 70.0283L29.3185 69.6371L24.2033 66.9193Z",
    fill: "#647893"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9333 72.7623C22.0444 72.7623 26.9985 62.7284 26.9985 50.3509C26.9985 37.9734 22.0444 27.9395 15.9333 27.9395C9.8222 27.9395 4.86816 37.9734 4.86816 50.3509C4.86816 62.7284 9.8222 72.7623 15.9333 72.7623Z",
    fill: "#647893"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1659 86.9997C12.7401 60.6406 17.1213 34.3774 17.166 34.1152L17.6068 34.1893C17.5621 34.4509 13.1939 60.6434 17.6069 86.9269L17.1659 86.9997Z",
    fill: "#3F3D56"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7764 45.7185L15.7703 51.0312L15.9811 51.4226L25.9873 46.1098L25.7764 45.7185Z",
    fill: "#3F3D56"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4207 48.3802L5.20972 48.7715L15.2144 54.087L15.4253 53.6957L5.4207 48.3802Z",
    fill: "#3F3D56"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1402 67.5299C50.5028 67.5299 57.282 53.7992 57.282 36.8616C57.282 19.924 50.5028 6.19336 42.1402 6.19336C33.7776 6.19336 26.9984 19.924 26.9984 36.8616C26.9984 53.7992 33.7776 67.5299 42.1402 67.5299Z",
    fill: "#647893"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9082 87.0004C37.8541 50.9433 43.8471 15.0178 43.9083 14.6592L44.349 14.7333C44.2879 15.0913 38.3078 50.9461 44.3492 86.9275L43.9082 87.0004Z",
    fill: "#3F3D56"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6484 30.5951L41.9558 37.8652L42.1667 38.2566L55.8592 30.9865L55.6484 30.5951Z",
    fill: "#3F3D56"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7161 34.2376L27.5051 34.6289L41.1958 41.9026L41.4067 41.5113L27.7161 34.2376Z",
    fill: "#3F3D56"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M169.342 79.4814C172.466 79.4814 174.999 74.3513 174.999 68.0229C174.999 61.6946 172.466 56.5645 169.342 56.5645C166.217 56.5645 163.685 61.6946 163.685 68.0229C163.685 74.3513 166.217 79.4814 169.342 79.4814Z",
    fill: "#3F3D56"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M168.819 86.7778C171.085 73.2832 168.842 59.8373 168.819 59.7031L168.379 59.7772C168.401 59.9107 170.631 73.286 168.378 86.705L168.819 86.7778Z",
    fill: "#647893"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M164.361 65.5588L164.151 65.9502L169.266 68.6664L169.477 68.2751L164.361 65.5588Z",
    fill: "#647893"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M174.666 66.9189L169.55 69.6367L169.761 70.028L174.877 67.3102L174.666 66.9189Z",
    fill: "#647893"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M182.935 72.7623C189.046 72.7623 194 62.7284 194 50.3509C194 37.9734 189.046 27.9395 182.935 27.9395C176.824 27.9395 171.87 37.9734 171.87 50.3509C171.87 62.7284 176.824 72.7623 182.935 72.7623Z",
    fill: "#647893"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M181.703 86.9997C186.128 60.6406 181.747 34.3774 181.702 34.1152L181.262 34.1893C181.306 34.4509 185.675 60.6434 181.262 86.9269L181.703 86.9997Z",
    fill: "#3F3D56"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M173.092 45.719L172.882 46.1104L182.888 51.4231L183.099 51.0318L173.092 45.719Z",
    fill: "#3F3D56"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M193.448 48.3798L183.443 53.6953L183.654 54.0866L193.658 48.7711L193.448 48.3798Z",
    fill: "#3F3D56"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M156.728 67.5299C165.09 67.5299 171.87 53.7992 171.87 36.8616C171.87 19.924 165.09 6.19336 156.728 6.19336C148.365 6.19336 141.586 19.924 141.586 36.8616C141.586 53.7992 148.365 67.5299 156.728 67.5299Z",
    fill: "#647893"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M154.96 87.0004C161.014 50.9433 155.021 15.0178 154.96 14.6592L154.519 14.7333C154.58 15.0913 160.56 50.9461 154.519 86.9275L154.96 87.0004Z",
    fill: "#3F3D56"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M143.22 30.595L143.009 30.9863L156.702 38.2564L156.913 37.8651L143.22 30.595Z",
    fill: "#3F3D56"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M171.152 34.2371L157.462 41.5107L157.673 41.902L171.363 34.6284L171.152 34.2371Z",
    fill: "#3F3D56"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M114.628 19.5814L116.418 18.1605C115.028 18.0083 114.456 18.761 114.223 19.3567C113.136 18.909 111.954 19.4958 111.954 19.4958L115.535 20.7862C115.354 20.3072 115.04 19.8893 114.628 19.5814Z",
    fill: "#3F3D56"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8848 7.0375L72.6746 5.61658C71.2842 5.46431 70.7129 6.21701 70.4791 6.81278C69.3929 6.36505 68.2104 6.95182 68.2104 6.95182L71.7914 8.24227C71.6107 7.76329 71.2962 7.34537 70.8848 7.0375Z",
    fill: "#3F3D56"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M142.235 1.44082L144.025 0.0198992C142.635 -0.132367 142.063 0.620332 141.83 1.2161C140.743 0.768372 139.561 1.35514 139.561 1.35514L143.142 2.64559C142.961 2.16661 142.647 1.74869 142.235 1.44082Z",
    fill: "#3F3D56"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M145.849 84.345C145.373 84.3449 144.905 84.4694 144.494 84.7058C144.075 84.3303 143.556 84.0835 142.999 83.9952C142.443 83.9069 141.872 83.981 141.357 84.2084C140.841 84.4358 140.404 84.8069 140.097 85.2765C139.79 85.7461 139.627 86.294 139.627 86.8538H148.561C148.512 86.1727 148.205 85.5352 147.702 85.0697C147.199 84.6042 146.536 84.3453 145.849 84.345Z",
    fill: "#3F3D56"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0568 84.345C54.581 84.3449 54.1136 84.4694 53.7018 84.7058C53.2835 84.3303 52.7644 84.0835 52.2076 83.9952C51.6507 83.9069 51.08 83.981 50.5647 84.2084C50.0494 84.4358 49.6117 84.8069 49.3048 85.2765C48.9978 85.7461 48.8348 86.294 48.8355 86.8538H57.7688C57.7201 86.1727 57.4132 85.5352 56.91 85.0697C56.4068 84.6042 55.7446 84.3453 55.0568 84.345Z",
    fill: "#3F3D56"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M101.522 84.345C101.046 84.3449 100.579 84.4694 100.167 84.7058C99.7488 84.3303 99.2298 84.0835 98.6729 83.9952C98.116 83.9069 97.5453 83.981 97.03 84.2084C96.5147 84.4358 96.0771 84.8069 95.7701 85.2765C95.4631 85.7461 95.3001 86.294 95.3008 86.8538H104.234C104.185 86.1727 103.879 85.5352 103.375 85.0697C102.872 84.6042 102.21 84.3453 101.522 84.345Z",
    fill: "#3F3D56"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7175 78.0107H65.9442V78.836H69.9638V86.6762H70.7951V78.836H86.4508V86.6762H87.2823V78.836H91.7175V78.0107Z",
    fill: "#3F3D56"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7681 75.542H65.9948V76.3673H91.7681V75.542Z",
    fill: "#3F3D56"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7681 73.4785H65.9948V74.3038H91.7681V73.4785Z",
    fill: "#3F3D56"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7681 71.415H65.9948V72.2403H91.7681V71.415Z",
    fill: "#3F3D56"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M131.961 78.0107H106.188V78.836H110.208V86.6762H111.039V78.836H126.695V86.6762H127.526V78.836H131.961V78.0107Z",
    fill: "#3F3D56"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M132.012 75.542H106.239V76.3673H132.012V75.542Z",
    fill: "#3F3D56"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M132.012 73.4785H106.239V74.3038H132.012V73.4785Z",
    fill: "#3F3D56"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M132.012 71.415H106.239V72.2403H132.012V71.415Z",
    fill: "#3F3D56"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 194,
    height: 87,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsByTextEmpty);
export default __webpack_public_path__ + "static/media/skillsByTextEmpty.0b35c6244c44ccaba5a252b757ff969d.svg";
export { ForwardRef as ReactComponent };